export default __webpack_public_path__ + "static/media/122.70e789d6.jpg";